import React from 'react';
import {Checkbox, Typography} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Actions from "../modules/actions";
import { connect } from "react-redux";
import Box from "../modules/Box";

const mapStateToProps = (state, ownProps) => {
  let facade = undefined;
  let data = {};
  const building = state.buildings.find(b => b.buildingId === state.currentBuildingId);
  if(building) {
    if(ownProps.isBuildingLevel) {
      if(building.responses && building.responses[ownProps.id]) {
        data = building.responses[ownProps.id];
      }
    } else {
      if(building.facades) {
        facade = building.facades.find(f => f.facadeId === state.currentFacadeId);
        if(facade && facade.responses && facade.responses[ownProps.id]) {
          data = facade.responses[ownProps.id];
        }
      }
    }
  }
  
  return ({
    currentBuildingId: state.currentBuildingId,
    currentFacadeId: state.currentFacadeId,
    data,
  });
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  localToggleCheckBox: (bId, fId, box, isBuildingLevel) =>
    dispatch(Actions.toggleCheckBox(bId, isBuildingLevel ? undefined : fId, ownProps.id, box)), // strange that ownProps does not contain props from mapStateToProps
});

const yesUseStyles = makeStyles(theme => ({
  root: {
    color: "green",
    '&$checked': {
      color: "green",
    },
  },
  checked: {},
}));

const noUseStyles = makeStyles(theme => ({
  root: {
    color: "orange",
    '&$checked': {
      color: "orange",
    },
  },
  checked: {},
}));

const toggleBoxHelper = (props, event, box) => {
  props.localToggleCheckBox(props.currentBuildingId, props.currentFacadeId, box, props.isBuildingLevel);
  event.preventDefault();
};

const Question = props => {
  const yesClasses = yesUseStyles();

  const noClasses = noUseStyles();

  const disabled = props.isBuildingLevel ? !props.currentBuildingId : !props.currentFacadeId;

  return (
    <div className="Question" style={{
      display: "flex",
      justifyContent: "flex-start",
      textAlign: "left",
    }}>
      <Checkbox classes={yesClasses} disabled={disabled} checked={!!props.data.yes}
        onClick={event => toggleBoxHelper(props, event, Box.YES)}/>
      <Checkbox classes={noClasses} disabled={disabled} checked={!!props.data.no}
        onClick={event => toggleBoxHelper(props, event, Box.NO)}/>
      <Typography>{props.text}</Typography>
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Question);


// WEBPACK FOOTER //
// ./src/pages/Question.js